import React, { useState } from "react";
import { ProcedureSelectionWizard } from "./ProcedureSelectionWizard";
import { HoistSelectionWizard } from "./HoistSelectionWizard";
import { ParametersWizard } from "./ParametersWizard";
import { ProcedureKey } from "../../data/procedures";
import { useStore } from "../../store";

export interface ProcedureOption {
  key: ProcedureKey;
  isDefault?: boolean;
}

interface HoistOption {
  id: string;
  title: string;
  description: string;
  selected: boolean;
}

export const SetupWizard: React.FC = () => {
  const { closeModal, setProcedure } = useStore();
  const [currentStep, setCurrentStep] = useState(0);
  const [wizardData, setWizardData] = useState({
    procedure: null as ProcedureOption | null,
    hoists: [] as HoistOption[],
    useTuggers: true,
    parameters: {},
  });

  const handleProcedureNext = (selectedProcedure: ProcedureOption) => {
    setWizardData({ ...wizardData, procedure: selectedProcedure });
    setCurrentStep(1);
  };

  const handleHoistsNext = (
    selectedHoists: HoistOption[],
    useTuggers: boolean
  ) => {
    setWizardData({ ...wizardData, hoists: selectedHoists, useTuggers });
    setCurrentStep(2);
  };

  const handleHoistsBack = () => {
    setCurrentStep(0);
  };

  const handleParametersStart = (parameters: any) => {
    // Complete wizard
    if (wizardData.procedure) {
      setProcedure(wizardData.procedure.key);
    }
    closeModal();
  };

  const handleParametersBack = () => {
    setCurrentStep(1);
  };

  const handleCancel = () => {
    closeModal();
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <ProcedureSelectionWizard
            onNext={handleProcedureNext}
            onCancel={handleCancel}
          />
        );
      case 1:
        return (
          <HoistSelectionWizard
            onNext={handleHoistsNext}
            onBack={handleHoistsBack}
          />
        );
      case 2:
        return (
          <ParametersWizard
            onStart={handleParametersStart}
            onBack={handleParametersBack}
          />
        );
      default:
        return null;
    }
  };

  return <div className="w-full">{renderCurrentStep()}</div>;
};
